import { useMemo } from 'react';

import { useFieldDependencyResolve } from '@/features/form-factory/components/fields/DynamicField/useFieldDependencyResolve';

interface BankBranchMetadata {
  name?: string;
  kana?: string;
  hira?: string;
  roma?: string;
}

function parseBankBranchMetadata(metadata: unknown): BankBranchMetadata {
  if (metadata && typeof metadata === 'object') {
    return metadata as BankBranchMetadata;
  }
  return {};
}

export const useBankBranches = (bankCode: string | undefined) => {
  const result = useFieldDependencyResolve(
    'BankCode',
    'BankBranchCode',
    bankCode ?? null,
    { enabled: !!bankCode },
  );

  const bankBranches = useMemo(
    () =>
      result.options.map((opt) => {
        const meta = parseBankBranchMetadata(opt.metadata);
        return {
          code: opt.value,
          name: meta.name ?? opt.label,
          searchKeywords: [meta.kana, meta.hira, meta.roma].filter(
            (v): v is string => typeof v === 'string',
          ),
        };
      }),
    [result.options],
  );

  return {
    bankBranches,
    isLoading: result.isLoading,
    isFetching: result.isLoading,
    error: result.hasError ? result.error : null,
  };
};
